import { useState } from "react";
import { useAuth } from "../AuthContext";

/**
 * Magic-link giriş modalı. Şifre yok — e-posta ile bağlantı gönderilir.
 * AuthContext.loginOpen true iken görünür.
 */
export default function Login() {
  const { loginOpen, setLoginOpen, signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [durum, setDurum] = useState("idle");   // idle | sending | sent | error
  const [hata, setHata] = useState("");

  if (!loginOpen) return null;

  const gonder = async (e) => {
    e.preventDefault();
    if (!email.trim() || durum === "sending") return;
    setDurum("sending"); setHata("");
    const r = await signIn(email.trim());
    if (r.ok) setDurum("sent");
    else { setDurum("error"); setHata(r.error || "Bağlantı gönderilemedi"); }
  };

  const kapat = () => { setLoginOpen(false); setDurum("idle"); setEmail(""); setHata(""); };

  return (
    <div onClick={kapat}
      style={{ position:"fixed", inset:0, background:"rgba(15,20,30,.55)", zIndex:1000,
               display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
      <div onClick={e => e.stopPropagation()}
        style={{ background:"#fff", borderRadius:14, width:"100%", maxWidth:400,
                 boxShadow:"0 20px 60px rgba(0,0,0,.3)", overflow:"hidden" }}>
        <div style={{ background:"linear-gradient(135deg,#111827,#1f2f4d)", color:"#fff", padding:"22px 24px" }}>
          <div style={{ fontSize:19, fontWeight:800 }}>FootballAgents'a giriş</div>
          <div style={{ fontSize:12.5, color:"#9fb6d4", marginTop:4 }}>
            Maç analizini başlatmak için üye girişi gerekir. Şifre yok — e-postana bir bağlantı yollarız.
          </div>
        </div>

        <div style={{ padding:"22px 24px" }}>
          {durum === "sent" ? (
            <div style={{ textAlign:"center", padding:"12px 0" }}>
              <div style={{ fontSize:40, marginBottom:10 }}>📬</div>
              <div style={{ fontWeight:700, fontSize:15, marginBottom:6 }}>Bağlantı gönderildi</div>
              <div style={{ fontSize:13, color:"#6b7280", lineHeight:1.5 }}>
                <strong>{email}</strong> adresine gelen bağlantıya tıkla, otomatik giriş yap.
                Postayı görmüyorsan spam klasörüne bak.
              </div>
              <button onClick={kapat}
                style={{ marginTop:16, padding:"9px 18px", borderRadius:8, border:"1px solid #e5e7eb",
                         background:"#fff", cursor:"pointer", fontSize:13, fontWeight:600 }}>Tamam</button>
            </div>
          ) : (
            <form onSubmit={gonder}>
              <label style={{ fontSize:11.5, fontWeight:700, color:"#6b7280", letterSpacing:".04em" }}>E-POSTA</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="ornek@eposta.com" autoFocus
                style={{ width:"100%", marginTop:6, padding:"11px 13px", borderRadius:9, fontSize:14,
                         border:"1px solid #d1d5db", boxSizing:"border-box" }} />
              {hata && <div style={{ fontSize:12, color:"#dc2626", marginTop:8 }}>{hata}</div>}
              <button type="submit" disabled={durum === "sending"}
                style={{ width:"100%", marginTop:14, padding:"12px", borderRadius:9, border:"none",
                         background:"#2563eb", color:"#fff", fontSize:14, fontWeight:700,
                         cursor: durum === "sending" ? "default" : "pointer", opacity: durum === "sending" ? .7 : 1 }}>
                {durum === "sending" ? "Gönderiliyor…" : "Giriş bağlantısı gönder"}
              </button>
              <div style={{ fontSize:11, color:"#9ca3af", marginTop:12, textAlign:"center", lineHeight:1.5 }}>
                Ücretsiz üyelik ile ayda 3 analiz. Aynı hesap TahminLigi ile ortaktır.
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
